module.exports = __webpack_public_path__ + "img/add-test.d2a97278.svg";